module.exports = __webpack_public_path__ + "images/artist_1080.79651c3a9464e674a2eae6d1633a8c82.png";